import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import ModalConfirmar from './ModalConfirmar';

const MODALIDADES = ['Presencial', 'Virtual', 'Híbrida'];

const ESTADOS = [
    { value: 1, label: 'Programada' },
    { value: 2, label: 'En Proceso' },
    { value: 3, label: 'Realizada' },
];

const getInitialState = (usuarioId) => ({
    titulo: '',
    descripcion: '',
    fecha: '',
    duracion: '',
    modalidad: '',
    cupo_maximo: '',
    id_instructor: usuarioId || '',
    estado: 1,
});

const ModalCapacitacion = ({
    isOpen,
    registro,
    onSave,
    onClose,
    usuarioId,
    perfilId,
    personal = [],
}) => {
    const [formData, setFormData] = useState(getInitialState(usuarioId));
    const [archivoAsistencia, setArchivoAsistencia] = useState(null);
    const [archivoEvidencia, setArchivoEvidencia] = useState(null);
    const [confirmGuardar, setConfirmGuardar] = useState(false);
    const fileRef = useRef(null);
    const fileEvidenciaRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            if (registro) {
                setFormData({
                    id_capacitacion: registro.id_capacitacion,
                    titulo: registro.titulo || '',
                    descripcion: registro.descripcion || '',
                    fecha: registro.fecha ? registro.fecha.split('T')[0] : '',
                    duracion: registro.duracion || '',
                    modalidad: registro.modalidad || '',
                    cupo_maximo: registro.cupo_maximo || '',
                    id_instructor: registro.id_instructor || '',
                    estado: registro.estado ?? 1,
                });
            } else {
                setFormData(getInitialState(usuarioId));
            }
            setArchivoAsistencia(null);
            setArchivoEvidencia(null);
            if (fileRef.current) fileRef.current.value = '';
            if (fileEvidenciaRef.current) fileEvidenciaRef.current.value = '';
        }
    }, [registro, isOpen, usuarioId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setArchivoAsistencia(e.target.files[0] || null);
    };

    const handleFileEvidenciaChange = (e) => {
        setArchivoEvidencia(e.target.files[0] || null);
    };

    const handleSubmit = async () => {
        if (!formData.titulo.trim()) {
            alert('El título es obligatorio.');
            return;
        }
        if (!formData.fecha) {
            alert('La fecha es obligatoria.');
            return;
        }
        if (!formData.duracion || Number(formData.duracion) < 1) {
            alert('La duración debe ser mayor a 0.');
            return;
        }
        if (!formData.modalidad) {
            alert('La modalidad es obligatoria.');
            return;
        }
        if (!formData.cupo_maximo || Number(formData.cupo_maximo) < 1) {
            alert('El cupo máximo debe ser mayor a 0.');
            return;
        }
        if (!formData.id_instructor) {
            alert('El instructor es obligatorio.');
            return;
        }

        const dataToSave = {
            ...formData,
            duracion: parseInt(formData.duracion),
            cupo_maximo: parseInt(formData.cupo_maximo),
            id_instructor: parseInt(formData.id_instructor),
            estado: parseInt(formData.estado),
            perfil_id: perfilId,
        };

        try {
            await onSave(dataToSave, archivoAsistencia, archivoEvidencia);
            onClose(true);
        } catch (error) {
            // error already alerted in parent
        }
    };

    return (
        <>
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="lg">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{registro ? 'EDITAR CAPACITACIÓN' : 'NUEVA CAPACITACIÓN'}</h1>
                    <Button className="close-btn" onClick={() => onClose()}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={(e) => e.preventDefault()}>

                        <FormGroup>
                            <Label>Título: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="text"
                                name="titulo"
                                value={formData.titulo}
                                onChange={handleChange}
                                placeholder="Título de la capacitación"
                                maxLength={255}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Descripción:</Label>
                            <Input
                                className="form-control"
                                type="textarea"
                                name="descripcion"
                                value={formData.descripcion}
                                onChange={handleChange}
                                placeholder="Descripción de la capacitación"
                                rows={3}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Fecha: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="date"
                                name="fecha"
                                value={formData.fecha}
                                onChange={handleChange}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Duración (minutos): <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="number"
                                name="duracion"
                                value={formData.duracion}
                                onChange={handleChange}
                                placeholder="Ej: 60"
                                min={1}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Modalidad: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="modalidad"
                                value={formData.modalidad}
                                onChange={handleChange}
                            >
                                <option value="">Seleccione...</option>
                                {MODALIDADES.map(m => (
                                    <option key={m} value={m}>{m}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Cupo Máximo: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="number"
                                name="cupo_maximo"
                                value={formData.cupo_maximo}
                                onChange={handleChange}
                                placeholder="Ej: 20"
                                min={1}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Instructor: <span style={{ color: 'red' }}>*</span></Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="id_instructor"
                                value={formData.id_instructor}
                                onChange={handleChange}
                            >
                                <option value="">Seleccione...</option>
                                {personal.map(u => (
                                    <option key={u.usuario_id} value={u.usuario_id}>
                                        {u.nombre_completo_usuario}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Estado:</Label>
                            <Input
                                className="form-control"
                                type="select"
                                name="estado"
                                value={formData.estado}
                                onChange={handleChange}
                            >
                                {ESTADOS.map(e => (
                                    <option key={e.value} value={e.value}>{e.label}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label>Documento de Asistencia {registro?.archivo_asistencia_url ? '(reemplazar)' : '(opcional)'}:</Label>
                            <div className="cap-upload-zone">
                                <span
                                    className="cap-upload-btn"
                                    onClick={() => fileRef.current?.click()}
                                >
                                    {archivoAsistencia ? archivoAsistencia.name : 'Seleccionar archivo (PDF / JPG / PNG)'}
                                </span>
                                <input
                                    ref={fileRef}
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                />
                            </div>
                            {archivoAsistencia && (
                                <small>
                                    <span
                                        style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }}
                                        onClick={() => { setArchivoAsistencia(null); if (fileRef.current) fileRef.current.value = ''; }}
                                    >
                                        ✕ Quitar selección
                                    </span>
                                </small>
                            )}
                            {registro?.archivo_asistencia_url && !archivoAsistencia && (
                                <small style={{ color: '#3cb167' }}>
                                    Documento ya subido.{' '}
                                    <span
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => window.open(`${process.env.REACT_APP_STORAGE_URL || 'http://127.0.0.1:8000/storage/'}${registro.archivo_asistencia_url}`, '_blank')}
                                    >
                                        Ver
                                    </span>
                                </small>
                            )}
                        </FormGroup>

                        <FormGroup>
                            <Label>Documento de Evidencia {registro?.archivo_evidencia_url ? '(reemplazar)' : '(opcional)'}:</Label>
                            <div className="cap-upload-zone">
                                <span
                                    className="cap-upload-btn"
                                    onClick={() => fileEvidenciaRef.current?.click()}
                                >
                                    {archivoEvidencia ? archivoEvidencia.name : 'Seleccionar archivo (PDF / JPG / PNG)'}
                                </span>
                                <input
                                    ref={fileEvidenciaRef}
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                    style={{ display: 'none' }}
                                    onChange={handleFileEvidenciaChange}
                                />
                            </div>
                            {archivoEvidencia && (
                                <small>
                                    <span
                                        style={{ cursor: 'pointer', color: '#f87171', fontSize: '10px' }}
                                        onClick={() => { setArchivoEvidencia(null); if (fileEvidenciaRef.current) fileEvidenciaRef.current.value = ''; }}
                                    >
                                        ✕ Quitar selección
                                    </span>
                                </small>
                            )}
                            {registro?.archivo_evidencia_url && !archivoEvidencia && (
                                <small style={{ color: '#3cb167' }}>
                                    Documento ya subido.{' '}
                                    <span
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => window.open(`${process.env.REACT_APP_STORAGE_URL || 'http://127.0.0.1:8000/storage/'}${registro.archivo_evidencia_url}`, '_blank')}
                                    >
                                        Ver
                                    </span>
                                </small>
                            )}
                        </FormGroup>

                        <FormGroup>
                            <div className="button-container">
                                <Button
                                    className="button-custom"
                                    onClick={() => setConfirmGuardar(true)}
                                >
                                    {registro ? 'ACTUALIZAR' : 'REGISTRAR'}
                                </Button>
                            </div>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </div>
        </Modal>

        <ModalConfirmar
            isOpen={confirmGuardar}
            titulo={registro ? 'Actualizar capacitación' : 'Registrar capacitación'}
            mensaje={registro ? '¿Está seguro de actualizar este registro?' : '¿Está seguro de registrar esta capacitación?'}
            textConfirmar={registro ? 'Actualizar' : 'Registrar'}
            textCancelar="Cancelar"
            variante=""
            onConfirmar={async () => {
                setConfirmGuardar(false);
                await handleSubmit();
            }}
            onCancelar={() => setConfirmGuardar(false)}
        />
        </>
    );
};

export default ModalCapacitacion;
